export function normalizeUrl(url) {
  return url.replace(/\/{2,}/g, '/');
}